import { HTMLAttributes, FC } from "react";
import { useStyles } from "./IOSInstallPopup.style";
import { useTranslation } from "react-i18next";
import { StaticImage } from "../StaticImage";
import HomeIcon from "./assets/home.webp";
import HomeIcon2x from "./assets/home@2x.webp";
import HomeIcon3x from "./assets/home@3x.webp";
import { Icon } from "../../core/Icon/Icon";
import { PopupType } from "../../../constants/popup";
import ExportIcon from "./assets/export.webp";
import ExportIcon2x from "./assets/export@2x.webp";
import ExportIcon3x from "./assets/export@3x.webp";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Dialog } from "../../core/Dialog/Dialog";
import { removePopupQueue } from "../../../store/slices/popup";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
export const IOSInstallPopup: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const dispatch = useAppDispatch();

  return (
    <Dialog
      className={classes.root}
      mainAction={{
        text: t("Ok"),
        onClick: () =>
          dispatch(removePopupQueue({ type: PopupType.IOSInstall })),
      }}
      open={currentPopupId === PopupType.IOSInstall}
    >
      <StaticImage
        src={HomeIcon}
        src2x={HomeIcon2x}
        src3x={HomeIcon3x}
        height={100}
      />
      <div className={classes.content}>
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {t("Add to Home Screen")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Silver}
          className={classes.label}
        >
          {t(
            "This website has app functionality. Add it to your home screen to use it in fullscreen and while offline.",
          )}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Silver}
        >
          1. {t("Open in Safari and press the ‘Share’")}{" "}
          <StaticImage
            src={ExportIcon}
            src2x={ExportIcon2x}
            src3x={ExportIcon3x}
            height={16}
            className={classes.image}
          />{" "}
          {t("button on the menu bar below")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Silver}
          className={classes.download}
        >
          2. {t("Press ‘Add to Home Screen’.")}{" "}
          <Icon
            name="icon-linear-add-square"
            size={16}
            className={classes.image}
          />
        </Typography>
      </div>
    </Dialog>
  );
};
